import React, {
	Dispatch, SetStateAction, useEffect, useMemo,
} from 'react';
import {
	BreakdownIcon, Dropdown, Label, Menu,
} from '@aleph/shared-components';
import {
	SpotifyBreakdowns,
	SpotifyLevel,
	SpotifyGroupBreakdowns,
	groupOnlyBreakdowns,
} from 'wb-spotify/app/routes/superGrid/utils';
import { startCase } from 'lodash';
import useSupergridSettings from 'wb-spotify/app/routes/superGrid/hooks/useSupergridSettings';

type SpotifySuperGridBreakdownSelectorProps = {
	selectedBreakdown: SpotifyBreakdowns | undefined;
	setSelectedBreakdownType: Dispatch<SetStateAction<SpotifyBreakdowns | undefined>>;
	level: SpotifyLevel;
};

const SpotifySuperGridBreakdownSelector = ({
	selectedBreakdown,
	setSelectedBreakdownType,
	level,
}: SpotifySuperGridBreakdownSelectorProps) => {
	const { setLifetimeStats } = useSupergridSettings();

	useEffect(() => {
		// If selected breakdown is a group-only breakdown and level is not GROUP, reset to ENTITIES
		if (
			selectedBreakdown
			&& groupOnlyBreakdowns.includes(selectedBreakdown as unknown as SpotifyGroupBreakdowns)
			&& level !== SpotifyLevel.GROUP
		) {
			setSelectedBreakdownType(SpotifyBreakdowns.ENTITIES);
		}
	}, [level, selectedBreakdown, setSelectedBreakdownType]);

	const onChange = (
		breakdown: SpotifyBreakdowns,
		onClose: { (delay?: number | undefined): void | NodeJS.Timeout; (): void; },
	) => {
		setLifetimeStats(false);
		setSelectedBreakdownType(breakdown);
		onClose();
	};

	const breakdowns = useMemo(
		() => (level === SpotifyLevel.GROUP ? SpotifyGroupBreakdowns : SpotifyBreakdowns),
		[level],
	);

	return (
		<Dropdown
			title={startCase(selectedBreakdown)}
			leftNode={<BreakdownIcon />}
		>
			{(closeDropdown) => (
				<Menu>
					{Object.values(breakdowns).map((breakdown, idx) => (
						<Menu.Item
							onClick={() => onChange(breakdown, closeDropdown)}
							selected={selectedBreakdown === breakdown}
							key={idx}
						>
							<Label>{startCase(breakdown)}</Label>
						</Menu.Item>
					))}
				</Menu>
			)}
		</Dropdown>
	);
};

export default SpotifySuperGridBreakdownSelector;
